var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7781C2.00296 19.5592 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5592 18.7782 18.7781C19.5593 17.997 19.9987 16.938 20 15.8333V8.33331H0V15.8333ZM14.1667 12.0833C14.4139 12.0833 14.6556 12.1566 14.8611 12.294C15.0667 12.4313 15.2269 12.6266 15.3215 12.855C15.4161 13.0834 15.4409 13.3347 15.3926 13.5772C15.3444 13.8197 15.2254 14.0424 15.0505 14.2172C14.8757 14.392 14.653 14.5111 14.4105 14.5593C14.1681 14.6075 13.9167 14.5828 13.6883 14.4882C13.4599 14.3936 13.2647 14.2333 13.1273 14.0278C12.99 13.8222 12.9167 13.5805 12.9167 13.3333C12.9167 13.0018 13.0484 12.6839 13.2828 12.4494C13.5172 12.215 13.8351 12.0833 14.1667 12.0833ZM10 12.0833C10.2472 12.0833 10.4889 12.1566 10.6945 12.294C10.9 12.4313 11.0602 12.6266 11.1548 12.855C11.2495 13.0834 11.2742 13.3347 11.226 13.5772C11.1777 13.8197 11.0587 14.0424 10.8839 14.2172C10.7091 14.392 10.4863 14.5111 10.2439 14.5593C10.0014 14.6075 9.75005 14.5828 9.52165 14.4882C9.29324 14.3936 9.09801 14.2333 8.96066 14.0278C8.82331 13.8222 8.75 13.5805 8.75 13.3333C8.75 13.0018 8.8817 12.6839 9.11612 12.4494C9.35054 12.215 9.66848 12.0833 10 12.0833ZM5.83333 12.0833C6.08056 12.0833 6.32223 12.1566 6.5278 12.294C6.73336 12.4313 6.89357 12.6266 6.98818 12.855C7.08279 13.0834 7.10755 13.3347 7.05931 13.5772C7.01108 13.8197 6.89203 14.0424 6.71722 14.2172C6.5424 14.392 6.31967 14.5111 6.0772 14.5593C5.83472 14.6075 5.58339 14.5828 5.35498 14.4882C5.12657 14.3936 4.93135 14.2333 4.794 14.0278C4.65664 13.8222 4.58333 13.5805 4.58333 13.3333C4.58333 13.0018 4.71503 12.6839 4.94945 12.4494C5.18387 12.215 5.50181 12.0833 5.83333 12.0833Z",
    fill: "url(#paint0_linear_188_245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 6.66667H20V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667Z",
    fill: "url(#paint1_linear_188_245)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_245",
    x1: 10,
    y1: 8.33331,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_245",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 6.66667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a5a48c169931d143e3f9709259b22c98.svg";
export { ForwardRef as ReactComponent };